/**
 * True when the episode's file is a video, so it is shown with the video player and kept out of the audio one.
 * The feed's own `type` decides: some publishers serve audio-only files as `.mp4`, and some video files carry
 * a query string, so the file name says too little. Only an episode without a usable type falls back to the name.
 */
export const isVideoEpisode = (episode: { sound: string; type?: string | null }): boolean => {
    const type = (episode.type ?? "").trim().toLowerCase();
    if (type.startsWith("video/")) return true;
    if (type.startsWith("audio/")) return false;

    const path = episode.sound.split(/[?#]/)[0].toLowerCase();
    return path.endsWith(".mp4");
};
